import { useQuery } from "@tanstack/react-query";

import { getDashboardSummary } from "@/api/dashboard";

export function useSummaryQuery(flightId?: number | null) {
  return useQuery({
    queryKey: ["dashboard", "summary", flightId ?? null],
    queryFn: () => getDashboardSummary(flightId ?? null),
    staleTime: 30_000,
  });
}
